module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h-1":"お知らせ"}}')
  delete Component.options._Ctor
}
